import { OrganizationUser } from "../../models/organization_users/organization_users.model";

export namespace OrganizationUsers {
	export class FetchAll {
		static readonly type = "[OrganizationUsers] Fetch all";
	}

	export class FetchUser {
		static readonly type = "[OrganizationUsers] Fetch user";
		constructor(public userId: number) {}
	}

	export class SetFilter {
		static readonly type = "[OrganizationUsers] Set Filter";
		constructor(public filter: any) {}
	}

	export class Add {
		static readonly type = "[OrganizationUsers] Add";
		constructor(public user: OrganizationUser) {}
	}

	export class Update {
		static readonly type = "[OrganizationUsers] Update";
		constructor(public userId: number, public user: OrganizationUser) {}
	}

	export class Delete {
		static readonly type = "[OrganizationUsers] Delete User";
		constructor(public userId: number) {}
	}
}
